<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1"><span class="CharOverride-2"><a id="_idTextAnchor000"></a>when the world screamed</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-2">Arthur Conan Doyle</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><img src="image/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-8-1.vue?5dc8e2e0